import * as Yup from "yup";
import { REPORT_ABUSE_TYPES } from "@/lib/constants";

const requiredString = Yup.string().required("Required");
const requiredEmail = Yup.string().email("Enter a valid email").required("Required");
const optionalUrl = Yup.string()
  .transform((v) => (v === "" ? undefined : v))
  .optional()
  .test("valid-url", "Enter a valid URL", (value) => {
    if (!value) return true;
    try {
      const urlToTest = /^https?:\/\//i.test(value) ? value : `https://${value}`;
      new URL(urlToTest);
      return true;
    } catch {
      return false;
    }
  });

export const emailOnlySchema = Yup.object({
  email: requiredEmail,
});

export const newsletterSchema = emailOnlySchema;
export const heroEmailSchema = emailOnlySchema;

export const contactSupportSchema = Yup.object({
  name: requiredString,
  email: requiredEmail,
  category: Yup.string().required("Please select a category"),
  message: requiredString,
});

export const contactSalesSchema = Yup.object({
  fullName: requiredString,
  workEmail: requiredEmail,
  useCase: Yup.string().required("Please select a use case"),
  message: Yup.string()
    .required("Please enter a message")
    .min(10, "Message must be at least 10 characters"),
});

const REPORT_ABUSE_TYPE_VALUES = REPORT_ABUSE_TYPES.map((type) => type.value);

export const reportAbuseSchema = Yup.object({
  reportType: Yup.string()
    .oneOf(REPORT_ABUSE_TYPE_VALUES, "Please select a report type")
    .required("Please select a report type"),
  fullName: requiredString,
  email: requiredEmail,
  incidentDate: requiredString,
  ips: requiredString,
  evidence: Yup.string().when("reportType", {
    is: "account_security",
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.required("Required"),
  }),
  destinationUrls: Yup.array().of(optionalUrl),
  attestation: Yup.boolean().oneOf([true], "Please confirm the accuracy of this report"),
});

export const writeForUsSchema = Yup.object({
  name: requiredString,
  email: requiredEmail,
  articleTitle: requiredString,
  articleLink: optionalUrl,
  bio: requiredString,
  socialUrl: Yup.string().url("Enter a valid URL").required("Required"),
});

export const betaTesterSchema = Yup.object({
  firstName: requiredString,
  lastName: requiredString,
  email: requiredEmail,
  startedUsing: Yup.string().required("Please select an option"),
  useCase: Yup.string().required("Please select an option"),
  technicalLevel: Yup.string(),
  featureRequests: Yup.string(),
});

export const partnerSchema = Yup.object({
  firstName: requiredString,
  businessEmail: requiredEmail,
  companyWebsite: optionalUrl,
  about: Yup.string(),
  agreed: Yup.boolean().oneOf([true], "Required"),
});

export const discordInviteSchema = Yup.object({
  name: requiredString,
  email: requiredEmail,
  discordUsername: requiredString,
  reason: requiredString,
});

export const hostingApplicationSchema = Yup.object({
  firstName: requiredString,
  lastName: requiredString,
  email: requiredEmail,
  phone: requiredString,
  addressLine1: requiredString,
  addressLine2: Yup.string(),
  city: requiredString,
  state: requiredString,
  zipCode: requiredString,
  addressType: Yup.string().required("Please select an option"),
  planMoving: Yup.string().required("Please select an option"),
  speedtestWifiUrl: Yup.string().url("Enter a valid URL").required("Required"),
  speedtestPhoneUrl: Yup.string().url("Enter a valid URL").required("Required"),
  carrier: Yup.string().required("Please select an option"),
  testEnvironment: Yup.string().required("Please select an option"),
  cellularSignal: requiredString,
  applyingForSelf: Yup.string().required("Please select an option"),
  referOthers: Yup.string().required("Please select an option"),
  additionalInfo: Yup.string(),
});

export const datacenterWaitlistSchema = Yup.object({
  fullName: requiredString,
  email: requiredEmail,
  company: Yup.string(),
  useCase: Yup.string(),
});

export const ispWaitlistSchema = Yup.object({
  fullName: requiredString,
  email: requiredEmail,
  company: Yup.string(),
  useCase: Yup.string(),
});

export const hostingReferralSchema = Yup.object({
  yourFirstName: requiredString,
  yourLastName: requiredString,
  yourEmail: requiredEmail,
  referFirstName: requiredString,
  referLastName: requiredString,
  referEmail: requiredEmail,
  informedReferral: Yup.boolean().oneOf([true], "Please confirm you've informed them"),
});
